module.exports = __webpack_public_path__ + "img/SC-4799.3f93c5ea.png";